import { get } from "lodash"
import { api } from "shared/redux/api"

import { objectToQueryString } from "shared/utils/common"

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDashboardLXOMyTask: build.query({
      query: (arg = {}) => {
        return {
          url: `/private/report/v1/lxo?${objectToQueryString(arg)}`,
        }
      },
    }),
    getReportLXOMyTask: build.query({
      query: (arg = {}) => {
        return {
          url: `/private/report/v1/dashboard?${objectToQueryString(arg)}`,
        }
      },
    }),
    getMyTeamLXO: build.query({
      query: (arg = {}) => {
        return {
          url: `/private/lxo/v1/team?${objectToQueryString(arg)}`,
        }
      },
    }),
    getAllTeamLXO: build.query({
      query: (arg = {}) => {
        return {
          url: `/private/lxo/v1/all-team`,
        }
      },
    }),
    getDetailLXOMyTeam: build.query({
      query: (arg = {}) => {
        const { teamId, ...rest } = arg
        return {
          url: `/private/lxo/v1/team/${teamId}?${objectToQueryString(rest)}`,
        }
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useLazyGetDashboardLXOMyTaskQuery,
  useLazyGetReportLXOMyTaskQuery,
  useLazyGetMyTeamLXOQuery,
  useLazyGetAllTeamLXOQuery,
  useLazyGetDetailLXOMyTeamQuery,
} = injectedRtkApi
